import { http } from './http';
export const announcementBase = (organizationId) => organizationId ? `/organizations/${organizationId}/announcements` : '/platform/announcements';
export async function announcementRequest(method, path, payload) {
  const { data } = await http.request({ method, url: path, ...(method === 'get' ? { params: payload } : { data: payload }) });
  // Unwrap only the API envelope; nested data belongs to Laravel pagination.
  return data && Object.prototype.hasOwnProperty.call(data, 'data') ? data.data : data;
}
export const channelLabels = { in_app: 'داخل پنل', email: 'ایمیل', sms: 'پیامک' };
export const statusLabels = { draft: 'پیش‌نویس', scheduled: 'زمان‌بندی‌شده', preparing: 'آماده‌سازی', sending: 'در حال ارسال', completed: 'تکمیل‌شده', partial: 'نیازمند پیگیری', cancelled: 'لغوشده', held: 'در حال آماده‌سازی', pending: 'در انتظار', processing: 'در حال پردازش', sent: 'پذیرفته‌شده', delivered: 'تحویل تأییدشده', failed: 'ناموفق', blocked_credit: 'کمبود اعتبار پیامک', missing_contact: 'فاقد اطلاعات تماس', requires_review: 'نتیجه نامشخص؛ نیازمند بررسی' };
export const announcementError = (e) => Object.values(e?.response?.data?.errors || {}).flat().join('؛ ') || e?.response?.data?.message || 'عملیات انجام نشد؛ دوباره تلاش کنید.';

/** تبدیل متن سادهٔ کاربر به HTML امن برای کانال ایمیل اطلاعیه */
export function plainTextToAnnouncementHtml(text) {
  const escaped = String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .trim();
  if (!escaped) return '';
  return escaped
    .split(/\n{2,}/)
    .map((block) => `<p>${block.replace(/\n/g, '<br>')}</p>`)
    .join('');
}

/**
 * ارسال ایمیل فوری به اعضای سازمان از مسیر اطلاعیهٔ سازمانی (فقط کانال email).
 * @param {string} organizationId
 * @param {{ subject: string, body: string, audience: object }} params
 */
export async function sendOrganizationMemberEmail(organizationId, { subject, body, audience }) {
  const base = announcementBase(organizationId);
  const title = String(subject || '').trim() || 'پیام سازمان';
  const htmlBody = plainTextToAnnouncementHtml(body);
  const payload = {
    title,
    audience,
    severity: 'info',
    popup: false,
    channels: {
      email: {
        subject: String(subject || '').trim() || title,
        body: htmlBody,
      },
    },
  };
  const preview = await announcementRequest('post', `${base}/preview`, payload);
  const emailCount = Number(preview?.counts?.email || 0);
  if (!emailCount) {
    const err = new Error('هیچ یک از گیرندگان انتخاب‌شده ایمیل معتبر ندارند.');
    err.code = 'NO_EMAIL_RECIPIENTS';
    err.preview = preview;
    throw err;
  }
  const saved = await announcementRequest('post', base, payload);
  if (saved?.status === 'draft' && saved?.id) {
    await announcementRequest('post', `${base}/${saved.id}/send`);
  }
  return { saved, preview };
}